import { render } from "./active-facets.vue?vue&type=template&id=5ed11a1f"
import script from "./active-facets.vue?vue&type=script&lang=js"
export * from "./active-facets.vue?vue&type=script&lang=js"

import "./active-facets.vue?vue&type=style&index=0&id=5ed11a1f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__